import type { FragmentType } from "../../../../../../__generated__/gql";
import { graphql, useFragment } from "../../../../../../__generated__/gql";

// 一覧（RoomTypeRow）とサイト詳細ドロワーの両方から呼ばれるため、
// 両クエリで spread できるよう fragment として切り出す。
export const FeatureSubtextFragment = graphql(`
  fragment FeatureSubtext_RoomType on RoomType {
    features {
      id
      slug
    }
  }
`);

/**
 * 部屋タイプの feature サブテキスト（Figma 898-37771 Slot2）。部屋名と価格の間に
 * 12px サブテキストで「焚き火台なし, EV充電器あり」をカンマ区切り表示。
 *
 * - 焚き火台なし: roomType.features に `no-firepit` があるか（部屋単位の確実な判定）。
 * - EV充電器あり: ⚠️ トリッキー。RoomType に「EVあり」フィールドは無いが、EVフィルター
 *   (evChargerAvailable=true) の検索では BE が EVCharger 付き部屋に限定して返すため、返却された
 *   部屋タイプは全て EV 可。よって evChargerAvailable=true のときのみ表示。false 時は部屋単位の
 *   EV 有無を判別できないため出さない。
 */
export function FeatureSubtext({
  roomType: roomTypeData,
  evChargerAvailable,
}: {
  roomType: FragmentType<typeof FeatureSubtextFragment>;
  evChargerAvailable: boolean;
}) {
  const roomType = useFragment(FeatureSubtextFragment, roomTypeData);
  const noFirepit = roomType.features.some((f) => f.slug === "no-firepit");
  if (!noFirepit && !evChargerAvailable) return null;
  return (
    <div className="font-notojp text-dx-text-default flex flex-wrap gap-x-[4px] text-[12px] leading-[18px]">
      {noFirepit && (
        <span className="whitespace-nowrap">
          焚き火台なし{evChargerAvailable && ","}
        </span>
      )}
      {evChargerAvailable && (
        <span className="whitespace-nowrap">EV充電器あり</span>
      )}
    </div>
  );
}
